export default __webpack_public_path__ + "static/media/thenate.a846d572.jpg";